import { KnockProvider as BaseKnockProvider } from "@knocklabs/react";
import { config } from "~/config";
import { useSession } from "~/hooks/useSession";
import { useI18n } from "~/lib/i18n/useI18n";
import { get } from "~/lib/lodash";

type Props = {
  children: JSX.Element;
};

export const KnockProvider: React.FC<Props> = ({ children }) => {
  const { user, knockUserToken } = useSession();
  const { i18n } = useI18n();

  if (!user) {
    return children;
  }

  if (!config.knock.publicKey || !knockUserToken) {
    console.warn("Knock is not configured");

    return children;
  }

  const translations = get(i18n.store.data, [i18n.language, "common", "knock"], {});

  return (
    <BaseKnockProvider
      apiKey={config.knock.publicKey}
      userId={user.id.toString()}
      userToken={knockUserToken}
      i18n={{ locale: i18n.language, translations }}
    >
      {children}
    </BaseKnockProvider>
  );
};
